/*
 * liens et boutons demandant une confirmation avant de valider
 */
$(document).on('click', 'a._confirm', function(e) {
	e.preventDefault();
	e.stopPropagation();

	var $this = $(this);
	var href = $this.attr('href');

	if( $this.is('[data-href]') )
		href = $this.data('href');

	var text = $this.is('[data-confirm]') ? $this.data('confirm') : __str('Are you sure?');

	if( confirm(text) )
		location.href = href;
	else
		return false;
});


$(document).on('click', 'button._confirm', function(e) {
	var $this = $(this);
	var text = $this.is('[data-confirm]') ? $this.data('confirm') : __str('Are you sure?');
	if( confirm(text) )
		return true;
	else {
		e.stopImmediatePropagation();
		return false;
	}
});
